import React from 'react'
import VirtualCardDetail, { VirtualCardDetailContext } from 'src/app/VirtualCardDetail/VirtualCardDetail'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletVirtualCardDetailRouteProps } from 'src/navigation/routeProps'

const MyWalletVirtualCardDetailAppRoute: AppRoute = {
  id: AppLocation.MyWalletVirtualCardDetail,
  routeProps: myWalletVirtualCardDetailRouteProps,
  component:<VirtualCardDetail context={VirtualCardDetailContext.myWallet} />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletVirtualCardDetailAppRoute
